import '@angular/google-maps';
// Function to convert degrees to radians
const degToRad = (degrees) => degrees * (Math.PI / 180);
// Function to calculate the distance between two points in kilometers
const haversine = (lat1, lon1, lat2, lon2) => {
    const earthRadius = 6371; // Radius of the Earth in kilometers
    // Convert latitude and longitude to radians
    const lat1Rad = degToRad(lat1);
    const lon1Rad = degToRad(lon1);
    const lat2Rad = degToRad(lat2);
    const lon2Rad = degToRad(lon2);
    // Calculate the differences between latitudes and longitudes
    const latDiff = lat2Rad - lat1Rad;
    const lonDiff = lon2Rad - lon1Rad;
    // Apply the Haversine formula
    const a = Math.sin(latDiff / 2) ** 2 +
        Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(lonDiff / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;
    return distance;
};
export const computeDistanceBetween = (from, to) => {
    return haversine(from.lat, from.lng, to.lat, to.lng);
};
export const getRadius = (mapBounds, mapCenter) => Math.min(haversine(0, mapBounds.lat, 0, mapCenter.lng), haversine(mapBounds.lat, 0, mapCenter.lat, 0));
